
import request from '@/utils/request'

function list (params) {
  const newParams = {...params};
  if (newParams.max) {
    newParams.take = newParams.max;
    delete newParams.max;
  }
  if (newParams.offset) {
    newParams.skip = newParams.offset;
    delete newParams.offset;
  }
    
  const qsParams = new URLSearchParams();
  for (let [key, value] of Object.entries(newParams)) {
    qsParams.append(key, value);
  }
  //console.log(`api.group-dept-member.list: qsParams = ${qsParams.toString()}`);
  return request({
    url: `/group-dept-member?${qsParams.toString()}`,
    method: 'get',
    data: newParams
  })
}
function get (itemId) {
  return request({
    url: `/group-dept-member/${itemId}`,
    method: 'get'
  })
}
function getWithTags (itemId) {
  return request({
    url: `/group-dept-member/${itemId}?relation=tags`,
    method: 'get'
  })
}
function getWithGroups (itemId) {
  return request({
    url: `/group-dept-member/${itemId}?relation=groups`,
    method: 'get'
  })
}
function search (params) {
  return request({
    url: `/group-dept-member/search`,
    method: 'post',
    data: params
  })
}
function add (params) {
  console.log(`api.groupDeptMember.add: params = ${JSON.stringify(params)}`)
  return request({
    url: `/group-dept-member`,
    method: 'post',
    data: params
  })
}
function update (params) {
  return request({
    url: `/group-dept-member/${params.id}`,
    method: 'patch',
    data: params
  })
}
function remove (itemId) {
  return request({
    url: `/group-dept-member/${itemId}`,
    method: 'delete'
  })
}
export default {
    list,
    search,
    add,
    update,
    remove,
    get,
    getWithTags,
    getWithGroups
}
